const E2E_ATTRIBUTE = "data-testid";

export function testLocator(locator: string | undefined): Record<string, string> {
  if (process.env.REACT_APP_ENV === "production") return {};

  // guard against empty locator which might be missing in .js files
  return locator ? { [E2E_ATTRIBUTE]: locator } : {};
}
